<template>
    <div>
        <div class="relative overflow-hidden">
            <picture class="w-full z-0">
                <source
                    media="(max-width: 768px)"
                    srcset="storage/pages/contact-us/bg-landing-page-mobile.png"
                />
                <img
                    src="storage/pages/contact-us/bg-landing-page.png"
                    alt=""
                    class="w-full"
                />
            </picture>
            <div
                class="w-full h-full absolute top-0 left-0 z-10 flex items-center md:items-start md:pt-200"
            >
                <div
                    class="w-full mx-150  md:mx-50 flex items-center justify-between md:justify-center "
                >
                    <div
                        class="text-black text-40 font-semibold pr-150 md:pr-0"
                    >
                        Contact Us
                        <span class="text-green-500 text-5xl">.</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="o">
            <div class="mx-150  md:mx-50 py-150">
                <div class="flex flex-col items-center justify-center">
                    <div class="w-full text-center mb-100">
                        <div class="mb-20" :class="this.$css.circleGreen">
                            <icon name="wa" class="w-5/12 h-auto fill-white" />
                        </div>
                        <div class="text-30">Call Center / Whatsapp</div>
                        <div class="text-60 font-semibold md:text-40">
                            +6281213655692
                        </div>
                    </div>
                    <div class="w-full text-center mb-100">
                        <div class="mb-20" :class="this.$css.circleGreen">
                            <icon
                                name="email"
                                class="w-5/12 h-auto text-white"
                            />
                        </div>
                        <div class="text-30">Email</div>
                        <div class="text-60 font-semibold md:text-40">
                            contribute@tanambenih.org
                        </div>
                    </div>
                    <div class="w-full text-center mb-100">
                        <div class="mb-20" :class="this.$css.circleGreen">
                            <icon name="map" class="w-5/12 h-auto text-white" />
                        </div>
                        <div class="text-30">Address</div>
                        <div class="text-60 font-semibold md:text-40">
                            Tanah Abang II no. 47, Petojo Selatan<br
                                class="md:hidden"
                            />Jakarta Pusat, 10160
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import Icon from "@/Shared/Icon";

export default {
    metaInfo() {
        return {
            title: this.head.title
        };
    },
    layout: Layout,
    components: {
        Icon
    },

    props: {
        head: Object
    }
};
</script>
